import { ElementUnderMousePointer } from '@ukpostbox/helpers';

const mailFolderDragImage = document.createElement('img');
mailFolderDragImage.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
mailFolderDragImage.width = 0;
mailFolderDragImage.height = 0;

const ResetFolderStates = () => {
	document
		.querySelectorAll('.folder-dropper-not-allowed')
		.forEach((folder) => folder.classList.remove('folder-dropper-not-allowed'));
};

const DisableFoldersById = (folderId: string) => {
	document
		.querySelectorAll(
			`.folder-entry[data-folder-id="${folderId}"], .custom-folder-list-entry[data-folder-id="${folderId}"]`,
		)
		.forEach((folder) => folder.classList.add('folder-dropper-not-allowed'));
};

const DragCustomFolder = (e: DragEvent) => {
	const target: HTMLElement | null = e.target as HTMLElement;
	const folderId = target.getAttribute('data-folder-id');
	const itemFolderId = target.getAttribute('data-folder-id') as string;

	if (e.dataTransfer) {
		e.dataTransfer.setData('text/html', target.className);
		e.dataTransfer.setData('text/plain', itemFolderId);
		e.dataTransfer.effectAllowed = 'none';
		e.dataTransfer.dropEffect = 'none';
		e.dataTransfer.setDragImage(mailFolderDragImage, window.outerWidth, window.outerWidth);
	}

	DisableFoldersById(itemFolderId);

	return { active: true, id: parseInt(folderId as string, 10) };
};

const DropCustomFolder = (e: DragEvent) => {
	if (!e.clientX || !e.clientY) return { active: false, id: -1 };

	const eventTarget: HTMLElement | null = e.target as HTMLElement;
	const target: Element | null = ElementUnderMousePointer(e.clientX, e.clientY) as HTMLElement;
	const eventFolderId = eventTarget?.getAttribute('data-folder-id')
		? parseInt(eventTarget.getAttribute('data-folder-id') as string, 10)
		: null;
	const folderId = target?.getAttribute('data-folder-id')
		? parseInt(target.getAttribute('data-folder-id') as string, 10)
		: null;

	if (!target.matches('.folder-entry-nested') && eventFolderId !== folderId) {
		target.classList.remove('folder-dropper');
		target.classList.remove('folder-dropper-not-allowed');

		return {
			targetId: folderId,
			currentId: e.dataTransfer?.getData('text/plain') ? parseInt(e.dataTransfer?.getData('text/plain'), 10) : -1,
		};
	}

	target.classList.remove('folder-dropper');
	target.classList.remove('folder-dropper-not-allowed');

	return { active: false, id: -1 };
};

const CustomFolderDragOver = (e: DragEvent) => {
	e.preventDefault();
};

const CustomFolderEnter = (e: DragEvent) => {
	const target: HTMLElement | null = e.target as HTMLElement;
	const draggingFolder = e.dataTransfer?.getData('text/html')
		? e.dataTransfer?.getData('text/html').indexOf('folder-entry') > -1
		: false;
	const itemFolderId = e.dataTransfer?.getData('text/plain')
		? parseInt(e.dataTransfer?.getData('text/plain'), 10)
		: null;
	const targetFolderId = parseInt(target.getAttribute('data-folder-id') || '-1', 10);

	if (target.matches('.folder-entry, .custom-folder-list-entry')) {
		target.classList.add('folder-dropper');
	}

	if (draggingFolder && (target.matches('.folder-entry-nested') || itemFolderId === targetFolderId)) {
		target.classList.add('folder-dropper-not-allowed');
	}
};

const CustomFolderLeave = (e: DragEvent) => {
	const target: HTMLElement | null = e.target as HTMLElement;
	const draggingFolder = e.dataTransfer?.getData('text/html')
		? e.dataTransfer?.getData('text/html').indexOf('folder-entry') > -1
		: false;

	if (target.matches('.folder-entry, .custom-folder-list-entry')) {
		target.classList.remove('folder-dropper');
	}

	if (draggingFolder && target.matches('.folder-dropper-not-allowed')) {
		target.classList.remove('folder-dropper-not-allowed');
	}
};

export {
	ResetFolderStates,
	DisableFoldersById,
	CustomFolderEnter,
	CustomFolderLeave,
	DragCustomFolder,
	CustomFolderDragOver,
	DropCustomFolder,
};
